/** i18n key under `templateEditor.*` for the right-panel title when editing this block type. */
export function templateEditorTitleKeyForBlockType(typeId: string): string {
  switch (typeId) {
    case 'block-button-one':
      return 'templateEditor.blockLink'
    case 'block-button-join':
      return 'templateEditor.blockJoin'
    case 'block-button-sales':
      return 'templateEditor.blockSales'
    case 'block-normal-text':
      return 'templateEditor.blockText'
    case 'block-image':
      return 'templateEditor.blockImage'
    case 'block-spacer':
      return 'templateEditor.blockSpacer'
    case 'block-video':
      return 'templateEditor.blockVideo'
    case 'block-Code':
      return 'templateEditor.blockCode'
    default:
      return 'templateEditor.sidebarElementsTab'
  }
}

/** 1-based section number from `sections.${index}`. */
export function humanSectionNumberFromEditKey(
  editElement: string,
): number | null {
  const keys = editElement.split('.')
  if (keys.length !== 2 || keys[0] !== 'sections') return null
  const n = Number(keys[1])
  if (!Number.isFinite(n) || n < 0) return null
  return n + 1
}

/** 1-based column index from `sections.${i}.innerStyles.${j}`. */
export function humanColumnNumberFromEditKey(
  editElement: string,
): number | null {
  const keys = editElement.split('.')
  if (keys.length !== 4 || keys[0] !== 'sections' || keys[2] !== 'innerStyles')
    return null
  const n = Number(keys[3])
  if (!Number.isFinite(n) || n < 0) return null
  return n + 1
}
